document.querySelectorAll('.sc-we-believe .green-bg-pattern-gradient.top').forEach((item) => {
  window.addEventListener('scroll', () => {
    const isAtTop = item.getBoundingClientRect().top <= 0;
    item.classList.toggle('is-active', isAtTop);
  });
});
